import { render } from "./TablaGafetes.vue?vue&type=template&id=66c17663&scoped=true"
import script from "./TablaGafetes.vue?vue&type=script&lang=js"
export * from "./TablaGafetes.vue?vue&type=script&lang=js"

import "./TablaGafetes.vue?vue&type=style&index=0&id=66c17663&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c17663"]])

export default __exports__